namespace RioERP.Web.Enums {
    export enum SourceType {
        Website = 1,
        Franchisee = 2,
        Others = 3,
        CounterOrder = 4
    }
    Serenity.Decorators.registerEnumType(SourceType, 'RioERP.Web.Enums.SourceType');
}
